export default {"src":"/_next/static/media/arrow-right.bff6485c.svg","height":10,"width":6};